import { memo } from 'react';

import { FrontButton } from '../../button/FrontButton';
import { XMarkIcon } from '../../icons/XMarkIcon';

interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
export const FrontModalCloseButton = memo(({ onClick }: Props) => {
  return (
    <FrontButton variant="quaternary" size="sm" isIcon onClick={onClick}>
      <XMarkIcon />
    </FrontButton>
  );
});
